/**
 * `/avisos` (E150.F1, GUS-150, ADR-0102 §4): os avisos da equipe que conduz o exame — o que os
 * clientes registraram na conversa dos casos: mensagem, questionamento, apontamento e ciência,
 * documento complementar e resposta a um pedido. Cada aviso leva à conversa do caso. A lista é a
 * mesma do portal (`Avisos/ListaDeAvisos`); mudam a rota, os tipos e o destino.
 */
import { ListaDeAvisos, type OrigemDosAvisos } from '@/components/Avisos/ListaDeAvisos';
import { ptBR } from '@/i18n/pt-BR';
import { getAvisosDaEquipe, marcarAvisoVistoDaEquipe } from '@/lib/avisos_da_equipe';
import type { AvisoTipo } from '@/lib/portal/avisos';

const t = ptBR.avisosDaEquipe;

const TIPO_LABEL: Partial<Record<AvisoTipo, string>> = {
  mensagem_do_cliente: t.tipoMensagemDoCliente,
  complemento_recebido: t.tipoComplementoRecebido,
  pedido_respondido: t.tipoPedidoRespondido,
};

const DA_EQUIPE: OrigemDosAvisos = {
  buscar: (client) => getAvisosDaEquipe(client),
  marcar: (client, aviso) => marcarAvisoVistoDaEquipe(client, aviso),
  linkDoAviso: (aviso) => `/casos/${aviso.case_id}/conversa`,
  rotuloDoTipo: (tipo) => TIPO_LABEL[tipo as AvisoTipo] ?? t.tipoIndefinido,
  textos: t,
  testId: 'avisos-da-equipe',
};

export function AvisosDaEquipePage(): JSX.Element {
  return (
    <section
      className="mx-auto flex max-w-4xl flex-col p-sc-6"
      data-testid="avisos-da-equipe-page"
      aria-labelledby="avisos-da-equipe-titulo"
    >
      <p className="mb-1.5 font-titulo text-rotulo uppercase text-fg-dim">{t.eyebrow}</p>
      <h1 id="avisos-da-equipe-titulo" className="text-display-sm text-fg">
        {t.titulo}
      </h1>
      <p className="mt-1 max-w-2xl text-body-sm text-fg-muted">{t.subtitulo}</p>
      <ListaDeAvisos origem={DA_EQUIPE} />
    </section>
  );
}
